import React from 'react'
import { useTranslation } from 'react-i18next'
import './WaitingPageUk.scss'

export const WaitingPageUk = () => {
    const { t } = useTranslation()

    return (
        <div className="waiting-page-uk">
            <div className="waiting-page-uk-content">
                <div className="waiting-page-uk-text">
                    <h1>{t('WaitingPageHeader')}</h1>

                    <p>{t('WaitingPageExplanation')}</p>
                </div>
            </div>
        </div>
    )
}